var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4189 14.9604H9.42808C9.14097 14.9604 8.9082 15.1932 8.9082 15.4803C8.9082 15.7674 9.14097 16.0002 9.42808 16.0002H14.4189C14.706 16.0002 14.9388 15.7674 14.9388 15.4803C14.9388 15.1932 14.706 14.9604 14.4189 14.9604Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31143 12.9834L0.155266 15.11C-0.174682 15.4355 0.0560392 16 0.520323 16H3.88219C4.02006 16 4.15228 15.9453 4.24977 15.8478L4.71277 15.3848L2.31143 12.9834Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70202 8.82764C3.12167 9.43884 2.88852 10.3178 3.09349 11.1378C3.18211 11.4923 3.13983 11.8642 2.98633 12.1869L5.51285 14.7134C5.83559 14.5599 6.20744 14.5176 6.56189 14.6062C7.38267 14.8114 8.26057 14.5775 8.87163 13.9973L3.70202 8.82764Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2435 2.24676L15.7459 0.624259C15.0274 -0.154099 13.8213 -0.211216 13.0322 0.4902L4.45703 8.11262L9.59157 13.2472L17.2498 4.87095C17.9292 4.12787 17.9275 2.98768 17.2435 2.24676Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.335f135a186c05c43b19e66cab9dc441.svg";
export { ForwardRef as ReactComponent };